
import { Label } from '@/components/ui/label';
import { ThumbnailUpload } from '../ThumbnailUpload';
import InsightCardPreview from './InsightCardPreview';

interface MetadataSidebarProps {
  thumbnailUrl: string;
  setThumbnailUrl: (url: string) => void;
}

const MetadataSidebar = ({
  thumbnailUrl,
  setThumbnailUrl,
}: MetadataSidebarProps) => {
  return (
    <div className="w-full bg-white">
      <Label className="sr-only">Featured Image</Label>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start">
        <div>
          <p className="mb-3 text-sm font-medium text-gray-700">
            Live card preview
          </p>
          <InsightCardPreview />
        </div>
        <div>
          <p className="mb-3 text-sm font-medium text-gray-700">
            Thumbnail image
          </p>
          <ThumbnailUpload
            currentThumbnail={thumbnailUrl}
            onThumbnailChange={setThumbnailUrl}
            compact
          />
        </div>
      </div>
    </div>
  );
};

export default MetadataSidebar;
